import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, S3Service } from '../../services';
import { RouteStateService } from '../forgot-password-get-email/verify-code/route-state.service';
import { WebSecurityMatrixService } from 'src/app/services/matrix/web-security-matrix.service';

export const AuthGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router)
    let isLoggedIn = authService.whenLoggedIn.getValue();

    if (!isLoggedIn){
        router.navigate(['/auth/login']);
    }

    return !!isLoggedIn;
}

export const GuestGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router)
    let isLoggedIn = authService.whenLoggedIn.getValue();

    if (isLoggedIn){
      router.navigate(['/']);
    }

    return !isLoggedIn;
}

export const DSIGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router)
    const routeStateService = inject(RouteStateService)

    const isLoggedIn = authService.whenLoggedIn.getValue();
    const { key } = route.queryParams;

    if (isLoggedIn) {
        if (state.url.includes('/dsi-viewer') && key) {
            return true;
        }
    } else {
        routeStateService.setRedirectUrl(state.url);
        router.navigate(['/auth/login']);
        return false;
    }
}

export const ReportGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router)
    const s3Service = inject(S3Service)

    let isLoggedIn = authService.whenLoggedIn.getValue();
    let isPedaAuth = window.location.href.includes("report-auth");

    const checkAndRefresh = () => {
      if (isPedaAuth && isLoggedIn) {
        const queryParams = new URLSearchParams(window.location.search);
        const type = queryParams.get('type');
        const key = queryParams.get('filename');
        const parts = key.split('/'); 
        const filename = parts[parts.length - 1]; 
        const bucketName = queryParams.get('bucketNameExport') || 'sfe-dev-testbucket';
        let isFile = key ? true : false;

        if (isFile) {
          const tempData = {
            bucketName: bucketName,
            key: decodeURIComponent(key),
            filename: decodeURIComponent(filename) // Assuming filename is needed for viewImage
          };

          if (type === "0") {
            s3Service.downloadObjectObservable(bucketName, key, filename).subscribe({
              next: (data) => {
                console.log('Download successful:', data);
              },
              error: (err) => {
                console.error('Download error:', err);
              },
              complete: () => {
                setTimeout(() => {
                  window.close();
                }, 2000);
              }
            });
          } else if (type === "1") {
            // Use viewImage method for type 1
            s3Service.viewImage(tempData, (err, data) => {
              if (err) {
                console.log(err);
                return err;
              } else {
              }
            });
          }
        }
      } else if (isLoggedIn) {
        router.navigate(['/']);
      }
    };

    // Initial check
    checkAndRefresh();

    // Set interval to check periodically
    setInterval(checkAndRefresh, 60000); // Check every 60 seconds

    return !isLoggedIn;
}

export const VerifyGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router)
    const routeStateService = inject(RouteStateService)

    const isComingFromForgotPassword = routeStateService.getFromForgotPassword();
    let isLoggedIn = authService.whenLoggedIn.getValue();
    if (isLoggedIn){
        router.navigate(['/']);
    }
    if(isComingFromForgotPassword){
        return true;
    } else {
        router.navigate(['/auth/login'])
        return false;
    }
}

export const WebMatrixGuard: CanActivateFn = (route, state) => {
    const router = inject(Router)
    const webMatrixService = inject(WebSecurityMatrixService)

    const requiredPermission = route.data['code'];
    if (webMatrixService.hasPermission(requiredPermission)) {
      return true;
    } else {
      router.navigate(['/not-authorized']);
      return false;
    }
}
